var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.47998 18.3505L10.58 20.7505C10.98 21.1505 11.88 21.3505 12.48 21.3505H16.28C17.48 21.3505 18.78 20.4505 19.08 19.2505L21.48 11.9505C21.98 10.5505 21.08 9.35052 19.58 9.35052H15.58C14.98 9.35052 14.48 8.85052 14.58 8.15052L15.08 4.95052C15.28 4.05052 14.68 3.05052 13.78 2.75052C12.98 2.45052 11.98 2.85052 11.58 3.45052L7.47998 9.55052",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37988 18.3505V8.55051C2.37988 7.15051 2.97988 6.65051 4.37988 6.65051H5.37988C6.77988 6.65051 7.37988 7.15051 7.37988 8.55051V18.3505C7.37988 19.7505 6.77988 20.2505 5.37988 20.2505H4.37988C2.97988 20.2505 2.37988 19.7505 2.37988 18.3505Z",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.875c89ae3331ba0c18efa252eb28caa7.svg";
export { ForwardRef as ReactComponent };